import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex w-full flex-col gap-3 md:gap-5',
    carousel: '[--slide-spacing:12px]',
    titleWrapper: 'md:w-5/6',
    title: 'heading-xl md:heading-2xl',

    banner: 'bg-accent group relative h-70 w-full',
    image: 'group-hover:brightness-80',
    bannerTitle: 'heading-italic-l underline decoration-1 underline-offset-4',
    bannerSubtitle: 'heading-s',
    content: [
      'absolute inset-0',
      'flex flex-col items-start gap-4 max-md:justify-end md:max-w-90',
      'p-5 md:p-10 md:pt-25 md:pb-5'
    ],
    button: 'heading-m-regular max-md:mt-3.5 md:mt-auto',
    link: 'absolute inset-0 opacity-0',

    viewportCarousel: '',

    arrow:
      'heading-2xl hover:text-accent -top-8.5 h-6 w-6 bg-transparent enabled:hover:bg-transparent',
    arrowNext: 'right-0 left-[unset]',
    arrowPrev: 'right-11 left-[unset]'
  },
  variants: {
    mode: {
      light: {
        content: 'text-white'
      },
      dark: {
        content: 'text-black'
      }
    },
    quantity: {
      one: {
        carousel: '[--slide-size:100%]'
      },
      couple: {
        viewportCarousel:
          '-ml-(--container-spacing) w-[calc(100%+var(--container-spacing)*2)] px-(--container-spacing) lg:ml-0 lg:w-full lg:px-0',
        carousel: '[--slide-size:auto] sm:[--slide-size:50%]'
      },
      many: {
        viewportCarousel:
          '-ml-(--container-spacing) w-[calc(100%+var(--container-spacing)*2)] px-(--container-spacing) lg:ml-0 lg:w-full lg:px-0',
        carousel: '[--slide-size:auto] lg:[--slide-size:calc(100%/2-124px)]'
      },
      'many-full': {
        viewportCarousel:
          '-ml-(--container-spacing) w-[calc(100%+var(--container-spacing)*2)] px-(--container-spacing) lg:ml-0 lg:w-full lg:px-0',
        carousel: '[--slide-size:auto] lg:[--slide-size:calc(100%/3)]'
      }
    }
  }
});
